/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningListType } from './InternalApiScreeningListType';
import {
    InternalApiScreeningListTypeFromJSON,
    InternalApiScreeningListTypeFromJSONTyped,
    InternalApiScreeningListTypeToJSON,
    InternalApiScreeningListTypeToJSONTyped,
} from './InternalApiScreeningListType';
import type { InternalApiNameExternalIdField } from './InternalApiNameExternalIdField';
import {
    InternalApiNameExternalIdFieldFromJSON,
    InternalApiNameExternalIdFieldFromJSONTyped,
    InternalApiNameExternalIdFieldToJSON,
    InternalApiNameExternalIdFieldToJSONTyped,
} from './InternalApiNameExternalIdField';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlowList
 */
export interface InternalApiScreeningFlowList {
    /**
     * 
     * @type {InternalApiScreeningListType}
     * @memberof InternalApiScreeningFlowList
     */
    type: InternalApiScreeningListType;
    /**
     * 
     * @type {InternalApiNameExternalIdField}
     * @memberof InternalApiScreeningFlowList
     */
    list: InternalApiNameExternalIdField;
    /**
     * 
     * @type {InternalApiNameExternalIdField}
     * @memberof InternalApiScreeningFlowList
     */
    usableField?: InternalApiNameExternalIdField;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlowList
     */
    selectorGroupCodes?: Array<string>;
}



/**
 * Check if a given object implements the InternalApiScreeningFlowList interface.
 */
export function instanceOfInternalApiScreeningFlowList(value: object): value is InternalApiScreeningFlowList {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowListFromJSON(json: any): InternalApiScreeningFlowList {
    return InternalApiScreeningFlowListFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowListFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowList {
    if (json == null) {
        return json;
    }
    return {
        
        'type': InternalApiScreeningListTypeFromJSON(json['type']),
        'list': InternalApiNameExternalIdFieldFromJSON(json['list']),
        'usableField': json['usableField'] == null ? undefined : InternalApiNameExternalIdFieldFromJSON(json['usableField']),
        'selectorGroupCodes': json['selectorGroupCodes'] == null ? undefined : json['selectorGroupCodes'],
    };
}

export function InternalApiScreeningFlowListToJSON(json: any): InternalApiScreeningFlowList {
    return InternalApiScreeningFlowListToJSONTyped(json, false);
}

export function InternalApiScreeningFlowListToJSONTyped(value?: InternalApiScreeningFlowList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': InternalApiScreeningListTypeToJSON(value['type']),
        'list': InternalApiNameExternalIdFieldToJSON(value['list']),
        'usableField': InternalApiNameExternalIdFieldToJSON(value['usableField']),
        'selectorGroupCodes': value['selectorGroupCodes'],
    };
}

